import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, useQueryClient, UseMutationResult } from 'react-query';
import { ErrorMessage, OtherWorkType, OtherWorkTypeWrite } from 'types';
import { client } from 'utils/api-client';

export default function useCreateOtherWorkType(): UseMutationResult<
  AxiosResponse<OtherWorkType>,
  AxiosError<ErrorMessage>,
  OtherWorkTypeWrite
> {
  const queryClient = useQueryClient();

  const createOtherWorkType = (otherWorkType: OtherWorkTypeWrite): Promise<AxiosResponse<OtherWorkType>> => {
    return client.post('other-work-types/', otherWorkType);
  };

  return useMutation(createOtherWorkType, {
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['otherWorkTypes'],
      });
      queryClient.invalidateQueries({
        queryKey: ['otherWorkPayRateLookups'],
      });
    },
  });
}
